
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import { User } from '@/views/Project/PSI/types/psi'

@Component({
    inheritAttrs: false,
    name: 'user-avatar',
    components: {},
})
export default class UserAvatar extends Mixins<MixinInterface>() {
    @Prop({}) user!: User | null

    get initials() {
        let initials: string | null = null
        if (this.user) {
            let names = this.user.name.split(' ')
            initials = names[0]?.split('')[0] + names.pop()?.split('')[0]
        }

        return initials
    }

    get avatar() {
        return this.user && this.user.avatarFileId ? this.getPreview(this.user.avatarFileId) : null
    }
}
